import * as config from '../config.js';
import { init_datalayer, push_utag_data } from '../init.js';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'datalayer_donation';

// Re-exports
export let global_vars = {};

export const PRODUCT = {
    id: [],
    list_name: [],
    name: [],
    category: [],
    list_position: [],
    price: [],

    promo_id: [],
    promo_name: [],
    promo_creative: [],
    promo_position: [],

    // These are not added to utag_data
    sku: [],
    list_variant: [],
    is_promo: '',
};

// ===========================================================================
// Donation data layer
// ===========================================================================

function update_data(global, utag_data, url, title) {
    // url should be the value of window.location.href
    // title should be the value of document.title

    // If product_category and product_name are undefined, then triggering the
    // tealium event will fail
    utag_data['product_category'] = '';
    utag_data['product_name'] = '';

    // These were not in the new document, so we're keeping
    // them around in case they're still being used.

    utag_data['page_url'] = url;
    utag_data['impression_sku'] = PRODUCT.id;
    utag_data['device_type'] = config.DEVICE.device;

    // These carried over from the old code
    utag_data['page_type'] = 'donations';
    utag_data['page_name'] = title;
    utag_data['impression_id'] = PRODUCT.id;

    // New
    utag_data['impression_list'] = PRODUCT.list_name;
    utag_data['impression_name'] = PRODUCT.name;
    utag_data['impression_category'] = PRODUCT.category;
    utag_data['impression_position'] = PRODUCT.list_position;
    utag_data['impression_price'] = PRODUCT.price;
    utag_data['page_category_sbu'] = 'ODN';
    utag_data['promo_imp_ids'] = PRODUCT.promo_id;
    utag_data['promo_imp_names'] = PRODUCT.promo_name;
    utag_data['promo_imp_creatives'] = PRODUCT.promo_creative;
    utag_data['promo_imp_positions'] = PRODUCT.promo_position;

    push_utag_data(utag_data);
}

// global is the window object when in the browser context this function should
export function initialize(global) {
    init_datalayer(global, () => {}, update_data);
}

// ===========================================================================

// ===========================================================================
